import type { Dictionnaire } from '../type';

export const commun: Dictionnaire['commun'] = {
  annuler: '取消',
  oui: '是',
  actions: '操作',
  confirmer: '确认',
  retour: '返回',
  reessayer: '重试',
  pleinEcran: '全屏查看照片',
  fermer: '关闭',
  enLigne: '在线',
  erreur: '出了点问题',
  serveur: {
    refuse: '这条消息不符合社区规则。',
    invalide: '消息无效',
    accesRefuse: '访问被拒绝。',
    indisponible: '暂时无法发布，请稍后再试。',
  },
  choisisUnSpot: '请先选择一个城市',
  membreInconnu: '未知成员',
  quelquun: '某人',
  nonConfigure: 'Firebase 尚未配置。请填写 client/.env.local（参见 client/.env.example）。',
  unInstant: '请稍候…',
  envoi: '发送中…',
  uneLangue: '请至少选择一种语言。',
};
